import { getLengthWithSpecialSymbols } from '@gem/utils';

import { MIN_FIELD_GROUP_NAME_LENGTH } from '../validation.constants';
import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

export const groupNameValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (!value || value.length === 0) {
    return errorToText[ValidationErrorType.Empty] || '';
  }

  if (getLengthWithSpecialSymbols(value) < MIN_FIELD_GROUP_NAME_LENGTH) {
    return errorToText[ValidationErrorType.TooShort] || '';
  }

  return null;
};
